import React, {useState} from 'react';
import Grid from "@material-ui/core/Grid";
import styled, {css} from "styled-components";
import {Trans} from "../../utils/i18n";
import {StatusCardComponent} from "./StatusCardComponent";
import HiddenStatus from "./HiddenStatus";
import {Button, IconButton} from "@mui/material";
import findIndex from "lodash/findIndex";
import classNames from "classnames";
import ExpandLessIcon from '@mui/icons-material/ExpandLess';

const ColumnRight = styled.div`
    border-left: 2px solid black;
    padding-left: 20px;
    min-height: 300px;
`;

const DetailsHeading = styled.h4`
    font-size: 12px;
    font-weight: 300;
    margin-bottom: 0;
`;

const DetailsValue = styled.h4`
    font-size: 16px;
    font-weight: 500;
    margin-top: 5px;
`;

export default function StatusFlow ({ data, flowsRef, }) {
    const lastSuccess = [...(data.statusFlow || [])].reverse().find(item => (item.datetime || item.exception));
    const lastSuccessIndex = findIndex([...(data.statusFlow || [])], lastSuccess);
    const [statusHidden, setStatusHidden] = useState(true);

    const chunk1 = (data.statusFlow && lastSuccessIndex > 0) ? data.statusFlow.slice(0, 1) : [];
    const chunk2 = data.statusFlow ? data.statusFlow.slice(1, lastSuccessIndex) : [];
    const chunk3 = data.statusFlow ? data.statusFlow.slice(lastSuccessIndex) : [];

    return (
        <Grid container spacing={3}>
            <Grid item xs={12} sm={7} ref={flowsRef}>
                {
                    chunk1.map((item, key) => {
                            return <StatusCardComponent key={key} item={item} displayArrow={true}/>;
                        }
                    )
                }
                <div className={classNames({
                    'flex flex-row divide-x-8 divide-[#46BA07] gap-3 w-full': !statusHidden,
                })}>
                    {
                       ! statusHidden &&
                        <div className={'flex items-start'}>
                            <IconButton onClick={() => setStatusHidden(true)}>
                                <ExpandLessIcon />
                            </IconButton>
                        </div>
                    }
                    <div className={classNames({
                        'pl-6 flex-1': !statusHidden,
                    })}>
                        {
                            chunk2.map((item, key) => {
                                    if(!statusHidden) {
                                        return <StatusCardComponent key={key} item={item} displayArrow={true} translate/>;
                                    }

                                    if(key === 0) {
                                        return <HiddenStatus item={item} setStatusHidden={setStatusHidden}/>;
                                    }

                                    return null;
                                }
                            )
                        }
                    </div>
                </div>
                {
                    chunk3.map((item, key) => {
                            return <StatusCardComponent key={key} item={item} displayArrow={key + 1 !== chunk3.length}/>;
                        }
                    )
                }
            </Grid>
            <Grid item xs={12} sm={1}>
            </Grid>
            <Grid item xs={12} sm={4}>
                <ColumnRight>
                    <div>
                        <DetailsHeading><Trans i18nKey="statusFlow.jobType">Job Type</Trans></DetailsHeading>
                        <DetailsValue>
                            { data.service?.name ? data.service?.name : '-' }
                        </DetailsValue>
                        <DetailsHeading><Trans i18nKey="statusFlow.jobNumber">Job number</Trans></DetailsHeading>
                        <DetailsValue>
                            { data.ordernumber }
                        </DetailsValue>
                        <DetailsHeading><Trans i18nKey="statusFlow.product">Product</Trans></DetailsHeading>
                        <DetailsValue>
                            { data.product.description }
                        </DetailsValue>
                        <DetailsHeading><Trans i18nKey="statusFlow.serialNumber">Serial number</Trans></DetailsHeading>
                        <DetailsValue>
                            { data.serialnumber }
                        </DetailsValue>
                        {
                            data.tid &&
                            <div>
                            <DetailsHeading><Trans i18nKey="statusFlow.tid">Terminal ID</Trans></DetailsHeading>
                            <DetailsValue>
                                { data.tid }
                            </DetailsValue>
                            </div>
                        }
                        <DetailsHeading><Trans i18nKey="statusFlow.quantity">Quantity</Trans></DetailsHeading>
                        <DetailsValue>
                            { data.quantity }
                        </DetailsValue>
                        { 
                            data?.warranty &&
                            <>
                                <DetailsHeading><Trans i18nKey="common.warranty">Warranty</Trans></DetailsHeading>
                                <DetailsValue>
                                { data.warranty }
                                </DetailsValue>
                            </>
                        }
                    </div>
                </ColumnRight>
            </Grid>
        </Grid>
    );
}
